<!--
  ~ Copyright (c) 2023 D2ArmorPicker by Mijago.
  ~
  ~ This program is free software: you can redistribute it and/or modify
  ~ it under the terms of the GNU Affero General Public License as published
  ~ by the Free Software Foundation, either version 3 of the License, or
  ~ (at your option) any later version.
  ~
  ~ This program is distributed in the hope that it will be useful,
  ~ but WITHOUT ANY WARRANTY; without even the implied warranty of
  ~ MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  ~ GNU Affero General Public License for more details.
  ~
  ~ You should have received a copy of the GNU Affero General Public License
  ~ along with this program.  If not, see <http://www.gnu.org/licenses/>.
  -->

<div *ngIf="item" class="item-icon-container">
  <img
    class="item-icon"
    src="https://bungie.net/{{ item.icon }}"
    loading="lazy"
    *ngIf="item.icon"
    #tooltip="matTooltip"
    matTooltip="{{ item.name }}" />

  <ng-container *ngIf="SpecialItemIconUrls[item.hash]">
    <img
      class="item-icon-overlay"
      [src]="SpecialItemIconUrls[item.hash]"
      [matTooltip]="item.name"
      #tooltip="matTooltip" />
  </ng-container>

  <img
    class="item-icon-overlay"
    src="https://bungie.net/{{ item.watermarkIcon }}"
    loading="lazy"
    *ngIf="item.watermarkIcon" />
  <img class="item-tier-overlay" [src]="tierIcon" *ngIf="tierIcon" alt="" />
  <div
    class="item-source-overlay"
    *ngIf="isFromVendor || isFromCollection"
    [class.vendor-item]="isFromVendor"
    [class.collection-item]="isFromCollection"></div>
  <div *ngIf="masterworked" class="item-icon-masterwork-overlay"></div>
</div>
